import React from 'react';
import { Link } from 'react-router-dom';

export default function AboutJornPage() {
  return (
    <>
      <title>Om Jørn - Rolskov Bowtech</title>
      <meta
        name="description"
        content="Mød Jørn Rolskov, uddannet lærer og Bowtechbehandler i Skårup på Fyn. Læs om hans baggrund, tilgang og erfaring med Bowtech."
      />
      <link rel="canonical" href="https://rolskov-bowtech.dk/om-jorn" />

      {/* Header Banner */}
      <section className="bg-[#f4efe6]/60 py-12 lg:py-16 border-b border-[#228A47]/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 space-y-4">
          <span className="text-xs font-semibold text-[#228A47] uppercase tracking-wider bg-[#e8f5ed] px-3 py-1 rounded-full">
            Din behandler
          </span>
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#062364]">
            Om Jørn Rolskov
          </h1>
          <p className="text-base sm:text-lg text-[#132038] max-w-3xl leading-relaxed">
            Certificeret Bowtechbehandler &amp; lærer med idræt som linjefag.
          </p>
        </div>
      </section>

      {/* Profile Details Section */}
      <section className="py-16 bg-[#faf8f5]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 space-y-16">
          
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-12 items-start">
            
            {/* Portrait */}
            <div className="lg:col-span-5 flex justify-center">
              <div className="relative rounded-3xl overflow-hidden border-2 border-[#228A47]/20 shadow-lg bg-white max-w-sm">
                <img
                  src="https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/0424b756-a2fd-4ec3-9a16-f52eef89d933/8408-edit.jpg"
                  alt="Portræt af Jørn Rolskov"
                  className="w-full h-auto object-cover"
                />
                <div className="p-4 bg-[#062364] text-white text-center">
                  <p className="text-base font-bold">Jørn Rolskov</p>
                  <p className="text-xs text-[#228A47] font-semibold">Bowtechbehandler i Skårup</p>
                </div>
              </div>
            </div>

            {/* Narrative */}
            <div className="lg:col-span-7 space-y-6 bg-white p-8 lg:p-10 rounded-3xl border border-[#228A47]/15 shadow-xs">
              <div className="space-y-1">
                <span className="text-xs font-semibold text-[#228A47] uppercase tracking-wider">
                  Baggrund &amp; Tilgang
                </span>
                <h2 className="text-2xl sm:text-3xl font-bold text-[#062364]">
                  Personlig fortælling
                </h2>
              </div>

              <div className="text-base text-[#132038] leading-relaxed space-y-4 font-normal">
                <p>
                  Jeg er uddannet lærer med idræt som linjefag.
                </p>
                <p>
                  Har i mange år arbejdet med gymnastik og idræt, hvor skader og behandling af disse har haft min interesse.
                </p>
                <p>
                  Blev uddannet Bowtechbehandler i november 2014, og har siden praktiseret behandlingen sideløbende med mit lærerjob.
                </p>
              </div>

              {/* Verified Facts */}
              <div className="pt-4 border-t border-[#f4efe6] grid grid-cols-1 sm:grid-cols-2 gap-4 text-xs font-medium text-[#062364]">
                <div className="p-3.5 bg-[#e8f5ed] rounded-xl flex items-center gap-3">
                  <i className="fa-regular fa-graduation-cap text-[#228A47] text-base" aria-hidden="true"></i>
                  <div>
                    <p className="font-bold text-[#062364]">Uddannet lærer</p>
                    <p className="text-slate-600">Idræt som linjefag</p>
                  </div>
                </div>

                <div className="p-3.5 bg-[#e8f5ed] rounded-xl flex items-center gap-3">
                  <i className="fa-regular fa-certificate text-[#228A47] text-base" aria-hidden="true"></i>
                  <div>
                    <p className="font-bold text-[#062364]">Bowtechbehandler</p>
                    <p className="text-slate-600">Uddannet nov. 2014</p>
                  </div>
                </div>
              </div>

            </div>

          </div>

          {/* Contact Box */}
          <div className="bg-[#062364] text-white p-8 lg:p-10 rounded-3xl text-center space-y-4">
            <h3 className="text-2xl font-bold">Kontakt Jørn Rolskov</h3>
            <p className="text-sm text-slate-200 max-w-xl mx-auto">
              Ring eller send en e-mail for at spørge ind til behandlingen eller booke en tid i Skårup.
            </p>
            <div className="pt-2 flex flex-wrap justify-center gap-4">
              <a
                href="tel:27117557"
                className="whitespace-nowrap px-6 py-3 text-sm font-semibold text-white bg-[#228A47] hover:bg-[#1b713a] rounded-xl transition-colors"
              >
                Ring på 27 11 75 57
              </a>
              <a
                href="mailto:joern@rolskov-bowtech.dk"
                className="whitespace-nowrap px-6 py-3 text-sm font-semibold text-white bg-white/10 hover:bg-white/20 rounded-xl transition-colors"
              >
                joern@rolskov-bowtech.dk
              </a>
            </div>
          </div>

        </div>
      </section>
    </>
  );
}
